import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "letters-access",
  "use": "letters-access-usage",
  "viewBox": "0 0 35 23",
  "content": "<symbol viewBox=\"0 0 35 23\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"letters-access\">\n  <path d=\"M11 22a5.7 5.7 0 0 1-.39-1.67 6.05 6.05 0 0 1-4.51 1.96 5.64 5.64 0 0 1-3.85-1.32c-1-.88-1.5-2-1.5-3.36 0-1.65.63-2.93 1.88-3.84 1.26-.92 3.02-1.38 5.3-1.38h2.64v-1.24c0-.95-.29-1.7-.85-2.26-.57-.57-1.4-.85-2.5-.85-.98 0-1.79.24-2.44.73-.65.5-.98 1.08-.98 1.77H1.07c0-.79.28-1.55.84-2.28A5.79 5.79 0 0 1 4.19 6.5a7.74 7.74 0 0 1 3.18-.64c1.83 0 3.26.46 4.3 1.37a4.92 4.92 0 0 1 1.6 3.77v7.3c0 1.45.2 2.6.56 3.47V22H11zm-4.5-2.07c.84 0 1.65-.22 2.41-.65a3.99 3.99 0 0 0 1.66-1.72v-3.25H8.44c-3.32 0-4.98.97-4.98 2.91 0 .85.28 1.52.85 2s1.3.71 2.18.71zm23.23-3.5h-8.94l-2 5.57h-2.9L24.02.67h2.46L34.65 22h-2.89l-2.03-5.57zm-8.09-2.31h7.25l-3.63-9.98-3.62 9.98z\" fill=\"#5E5E5E\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/letters-access.svg
// module id = 442
// module chunks = 0